// @flow

import prefersReducedMotion from './prefersReducedMotion';
import motionPreferences, { type MotionPreference } from './motionPreferences';

export default prefersReducedMotion;

export { motionPreferences };
export type { MotionPreference };
